import { motion } from "framer-motion"
import type { ReactNode } from "react"
import { fadeUp, staggerContainer } from "@/shared/lib/motion"
import { cn } from "@/shared/lib/utils"

interface RevealProps {
	children: ReactNode
	className?: string
	delay?: number
}

export function Reveal({ children, className, delay = 0 }: RevealProps) {
	return (
		<motion.div
			className={className}
			variants={fadeUp}
			initial="hidden"
			animate="visible"
			transition={delay ? { delay } : undefined}
		>
			{children}
		</motion.div>
	)
}

interface RevealListProps {
	children: ReactNode
	className?: string
	stagger?: number
	delayChildren?: number
	disabled?: boolean
}

export function RevealList({
	children,
	className,
	stagger,
	delayChildren,
	disabled = false,
}: RevealListProps) {
	if (disabled) return <div className={className}>{children}</div>

	return (
		<motion.div
			className={className}
			variants={staggerContainer(stagger, delayChildren)}
			initial="hidden"
			animate="visible"
		>
			{children}
		</motion.div>
	)
}

export function RevealItem({ children, className }: { children: ReactNode; className?: string }) {
	return (
		<motion.div className={cn(className)} variants={fadeUp}>
			{children}
		</motion.div>
	)
}
